import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { LOCAL__ui_grids2d_set_current_cell } from '@/state/ui/image/LOCAL__ui_grids2d_set_current_cell';
import { LOCAL__ui_grids2d_set_current_cell_neigbours } from '@/state/ui/image/LOCAL__ui_grids2d_set_current_cell_neigbours';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { DTO__grid2d_cell } from '@shared/dto/grid2d_cell/DTO__grid2d_cell';
import { FN_GRID2D_GALLERY__set_cell_current } from './FN_GRID2D_GALLERY__set_cell_current';

interface PROPS {
  grid2d: DTO__grid2d;
}

export function WATCHER_GRID2D_GALLERY__cell_current_update({ grid2d }: PROPS) {
  const dispatch = use_dispatch();
  const { global__grid2d_gallery_cell_current, global__grid2d_show_as_gallery } = use_slice_ui([
    'global__grid2d_gallery_cell_current',
    'global__grid2d_show_as_gallery',
  ]);

  /*
   *
   */

  use_effect(() => {
    try_set_current_cell();

    return () => {
      if (global__grid2d_gallery_cell_current._id == grid2d._id) {
        cleanup_current_cell();
      }
    };
  }, [global__grid2d_show_as_gallery, grid2d]);

  function try_set_current_cell() {
    if (global__grid2d_gallery_cell_current.grid2d_id == grid2d._id) return; //already set

    let cells = grid2d.cells__get_list();

    if (cells.is_empty()) return cleanup_current_cell(); //no cells

    FN_GRID2D_GALLERY__set_cell_current(grid2d, cells[0]);
  }

  function cleanup_current_cell() {
    dispatch(LOCAL__ui_grids2d_set_current_cell(DTO__grid2d_cell.CREATE_STUB()));

    dispatch(LOCAL__ui_grids2d_set_current_cell_neigbours([]));
  }

  return null;
}
